<template>
  <div class="main-content" :style="{height: mainContentHeight}">
    <transition name="fadeIn">
      <MainPage v-if="!hidden && currentPage === 1">
        <template v-slot:ghost-text>{{ strings.mainPageGhostText }}</template>
        <template v-slot:text-content>
          <h1>{{ strings.mainPageTitle }}</h1>
          <h2>{{ strings.mainPageSubtitle }}</h2>
          <a href="#" class="btn start" @click.prevent="startStories">{{ strings.startBtnText }}</a>
        </template>
      </MainPage>
    </transition>
    <transition name="slideUp">
      <StoriesSlider v-if="currentPage === 2" />
    </transition>
    <transition name="slideLeft">
      <Category v-if="isCategoryOpened" />
    </transition>
  </div>
</template>

<script>
import MainPage from "./MainPage.vue";
import StoriesSlider from "./StoriesSlider.vue";
import Category from "./Category.vue";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      activeStory: null,
      hidden: true,
    };
  },
  mounted() {
    this.loadData();
    this.hidden = false;
  },
  methods: {
    ...mapActions([
      "loadData",
      "changePage",
      "changeCategory",
      "toggleCategoriesPopup",
    ]),
    startStories() {
      this.changePage(2);
    },
    changeActiveStory(story) {
      this.activeStory = story;
      setTimeout(() => {
        this.activeStory = null;
      }, 200);
    },
  },
  computed: {
    ...mapState([
      "currentStoryIndex",
      "categories",
      "stories",
      "orbitImages",
      "currentPage",
      "isCategoryOpened",
      "windowHeight",
      "headerHeight",
      "strings",
    ]),
    ...mapGetters(["isMobileView"]),
    mainContentHeight() {
      return this.isMobileView
        ? this.currentPage === 1 ||
          this.currentStoryIndex === this.stories.length
          ? `${this.windowHeight}px`
          : `auto`
        : `calc(100% - ${this.headerHeight}px`;
    },
  },
  components: { MainPage, StoriesSlider, Category },
};
</script>

<style lang="scss">
.main-content {
  width: 100vw;
}

.main-content {
  &#portrait {
    position: absolute;
    overflow-x: hidden;
    top: 0;
  }
}
</style>